import { GridStack } from 'gridstack'

export function useDashboardGrid() {
  let grid = null

  const init = (el, onLayoutChange, onResizeStop) => {
    grid = GridStack.init(
      {
        column: 12,
        cellHeight: 50,
        margin: 12,
        animate: true,
        float: false,
        handle: '.q-card__section',
      },
      el,
    )
    grid.on('change', (_event, items) => {
      if (!onLayoutChange || !items) return
      const positions = {}
      items.forEach(item => {
        if (item.id) positions[item.id] = { x: item.x, y: item.y, w: item.w, h: item.h }
      })
      onLayoutChange(positions)
    })
    grid.on('resizestop', (_event, el) => {
      const id = el.getAttribute('gs-id')
      if (onResizeStop && id) onResizeStop(id)
    })
    grid.on('dragstart', () => document.body.classList.add('grid-stack-dragging'))
    grid.on('dragstop', () => document.body.classList.remove('grid-stack-dragging'))
  }

  const resetItems = (tiles) => {
    if (!grid) return
    tiles.forEach(tile => {
      const el = grid.el?.querySelector(`[gs-id="${tile.id}"]`)
      if (el) grid.update(el, { x: tile.x, y: tile.y, w: tile.w, h: tile.h })
    })
  }

  const destroy = () => {
    document.body.classList.remove('grid-stack-dragging')
    grid?.destroy(false)
    grid = null
  }

  return { init, destroy, resetItems }
}
